import React from 'react'
import {
  Box,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
} from '@mui/material'
import CustomerLayout from '@/components/Layout/CustomerLayout'
import { mockOrders } from '@/data/mockData'

export const CustomerOrderHistoryPage: React.FC = () => {
  return (
    <CustomerLayout>
      <Box sx={{ maxW: 1000, mx: 'auto' }}>
        <Typography variant="h4" fontWeight={700} gutterBottom sx={{ color: '#0f172a' }}>
          マイ注文履歴
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
          これまでにGoogleアカウントでご注文されたお荷物の状況・決済ステータス一覧です。
        </Typography>

        <Paper elevation={0} sx={{ p: 3, borderRadius: 3, border: '1px solid #e2e8f0' }}>
          <TableContainer>
            <Table>
              <TableHead sx={{ bgcolor: '#f8fafc' }}>
                <TableRow>
                  <TableCell sx={{ fontWeight: 700 }}>注文ID / 日時</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>商品・数量</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>お届け先名</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>合計金額</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>決済ステータス</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>追跡番号</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {mockOrders.map((order) => {
                  const status = order.PaymentStatus || (order.OrderId % 2 === 0 ? 'paid' : 'authorized')
                  return (
                    <TableRow key={order.OrderId} hover>
                      <TableCell>
                        <Typography variant="body2" fontWeight={700}>
                          #{order.OrderId}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          {order.OrderDate}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2">
                          {order.OrderDetails?.[0]?.ProductName || '桃 5kg'}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          数量: {order.ItemCount || 1}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2">
                          {order.OrderDetails?.[0]?.ConsigneeName || 'お届け先様'}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2" fontWeight={700}>
                          ¥{order.OrderTotal.toLocaleString()}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        {status === 'authorized' && (
                          <Chip label="仮売上（与信中）" color="warning" size="small" sx={{ fontWeight: 700 }} />
                        )}
                        {status === 'paid' && (
                          <Chip label="実売上（決済完了）" color="success" size="small" sx={{ fontWeight: 700 }} />
                        )}
                        {status === 'canceled' && (
                          <Chip label="キャンセル済み" color="default" size="small" />
                        )}
                      </TableCell>
                      <TableCell>
                        <Typography variant="caption" sx={{ fontFamily: 'monospace' }}>
                          {order.TrackingNumber || '発送準備中'}
                        </Typography>
                      </TableCell>
                    </TableRow>
                  )
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </Box>
    </CustomerLayout>
  )
}
export default CustomerOrderHistoryPage
